import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import { Maximize2, Minimize2 } from 'lucide-react';

export interface HeaderProps {
  title: string;
  titleIcon?: React.ReactNode;
  isFullScreen: boolean;
  toggleFullScreen: () => void;
  onClose: () => void;
  isSize?: boolean;
}

export function Header({ title, titleIcon, isFullScreen, toggleFullScreen, onClose, isSize }: HeaderProps) {
  return (
    <div className='flex items-center justify-between border-b border-[#e0e0e0] bg-[#f2f7fc] px-4 py-2'>
      <div className='flex items-center gap-2 font-bold'>
        {titleIcon}
        <span className='font-medium text-[#787879]'>{title}</span>
      </div>

      <div className='flex gap-1'>
        {isSize && (
          <button
            className='rounded-full p-1 hover:bg-gray-200'
            onClick={toggleFullScreen}
            title={isFullScreen ? 'Thoát toàn màn hình' : 'Toàn màn hình'}
          >
            {isFullScreen && <Minimize2 className='size-4' />}
            {!isFullScreen && <Maximize2 className='size-4' />}
          </button>
        )}

        <button className='rounded-full p-1 hover:bg-gray-200' onClick={onClose} title='Đóng'>
          <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-4' />
        </button>
      </div>
    </div>
  );
}

export default Header;
